import { Yup } from 'cng-web-lib'
import Namespace from 'src/constants/locale/Namespace'
import {
  constants,
} from 'cng-web-lib'
import moment from 'moment'
import AceHwyInbondArrivalKeys from 'src/constants/locale/key/AceHwyInbondArrival'

const {
  locale: {
    key: {
      CommonValidationMessageKeys,
    },
  },
} = constants


function makeValidationSchema(translate) {
  let requiredMessage = translate(
    Namespace.COMMON_VALIDATION_MSG,
    CommonValidationMessageKeys.REQUIRED
  )
  let dateTypeErrorMessage = translate(
    Namespace.COMMON_VALIDATION_MSG,
    CommonValidationMessageKeys.DATE_TYPE_ERROR
  )
  const alphaNumericMessage = translate(
    Namespace.COMMON_VALIDATION_MSG,
    AceHwyInbondArrivalKeys.validation.ALPHA_NUMERIC
  )
  const tripNumberMaxLengthMessage = translate(
    Namespace.COMMON_VALIDATION_MSG,
    AceHwyInbondArrivalKeys.validation.TRIP_NO_MAX_LENGTH
  )
  const dateFormatErrorMessage = translate(
    Namespace.COMMON_VALIDATION_MSG,
    AceHwyInbondArrivalKeys.validation.DATE_FORMAT_ERROR
  )
  const inbondNumberMaxLengthMessage = translate(
    Namespace.COMMON_VALIDATION_MSG,
    AceHwyInbondArrivalKeys.validation.INBOND_NUMBER_MAX_LENGTH
  )
const today = new Date();
today.setHours(0, 0, 0, 0);

  return Yup.object({
    tripNo: Yup.string().required(requiredMessage).matches("^[a-zA-Z0-9]+$",alphaNumericMessage).nullable().max(35,tripNumberMaxLengthMessage).nullable(),
    etaFirstPortUS: Yup.string().required(requiredMessage).test(
      'etaFirstPortUS',
      dateFormatErrorMessage,
      value => {
        var formattedDate = moment(value).format('YYYY-MM-DD')
        var formattedToday = moment(today).format('YYYY-MM-DD')
             return moment(formattedDate).isValid();
                   }
                 ).nullable(),
    firstPort: Yup.string().required(requiredMessage).nullable(),
    inbond7512No: Yup.string().required(requiredMessage).matches("^[a-zA-Z0-9]+$",alphaNumericMessage).max(9,inbondNumberMaxLengthMessage).nullable(),
    inbondDate: Yup.string().required(requiredMessage).test(
      'inbondDate',
      dateFormatErrorMessage,
      value => {
        var formattedDate = moment(value).format('YYYY-MM-DD')
        var formattedToday = moment(today).format('YYYY-MM-DD')
             return moment(formattedDate).isValid();
                   }
                 ).nullable(),
    inbondDestination: Yup.string().required(requiredMessage).nullable(),
    firmsCode: Yup.string().when(['messageCode', 'msgFunction'], {
      is: (messageCode, msgFunction) => (messageCode == '98' && msgFunction == '64'),
      then: Yup.string().required(requiredMessage),
    }).nullable(),
    msgFunction: Yup.number().required(requiredMessage).nullable(),
    messageCode: Yup.number().required(requiredMessage).nullable(),
  })
}

export default makeValidationSchema
